'use strict';

exports.__esModule = true;
var namespace = 'DIALOGS';

var ON_DIALOG_OPEN_CHANGED = exports.ON_DIALOG_OPEN_CHANGED = namespace + '@ON_DIALOG_OPEN_CHANGED';


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmw-shell/lib/store/dialogs/types.js
// module id = 289
// module chunks = 49